import { type AxiosResponse } from 'axios';

import { ordersAPI } from '~/services/api';
import { WEB_ORDERS_API } from '~/services/web-orders.service';
import { type DuplicatedOrderStatus } from '~/types/Order';

/**
 * Clones an order with the specified order ID.
 *
 * @param {string} orderId - The ID of the order to be cloned.
 *
 * @return {Promise<AxiosResponse<string>>} - A promise that resolves to the response received from the server for the clone order request.
 */
export const cloneOrder = (orderId: string): Promise<AxiosResponse<DuplicatedOrderStatus>> =>
  ordersAPI.request({
    method: 'POST',
    url: `${WEB_ORDERS_API}/${orderId}/clone`,
  });
